import tpl from './developQuick.html';
import "./developQuick.css";

class DevelopQuick {
    constructor(container, opts) {
        this.container = container;
        this.container.innerHTML = tpl;
    }
}

export {
    DevelopQuick
}